import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { Pf16Service } from 'src/app/services/pf16.service';

@Component({
  selector: 'app-edit-pf16',
  templateUrl: './edit-pf16.component.html',
  styleUrls: ['styles.css'
  ]
})
export class EditPf16Component implements OnInit {

  public questions;
  public pf16Form = this.fb.group({
    title: ['', Validators.required],
    _id:[''],
    opcA: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    opcB: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    opcC: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    factor: [''],
    index:['']
  });

  constructor( private pf16Service: Pf16Service, private fb: FormBuilder, private adminService:AdminServiceService) {
    pf16Service.getQuestions().subscribe(
      resp=>{
        this.questions = resp;
      },
      err=>console.log(err)
    )
  }

  ngOnInit(): void {
  }

  handleEdit(id){
    this.pf16Service.getQuestion(id).subscribe(
      resp=>{
        this.pf16Form.get('_id').patchValue(resp._id);
        this.pf16Form.get('title').patchValue(resp.title);
        this.pf16Form.get('opcA.text').patchValue(resp.opcA.text);
        this.pf16Form.get('opcA.value').patchValue(resp.opcA.value);
        this.pf16Form.get('opcB.text').patchValue(resp.opcB.text);
        this.pf16Form.get('opcB.value').patchValue(resp.opcB.value);
        this.pf16Form.get('opcC.text').patchValue(resp.opcC.text);
        this.pf16Form.get('opcC.value').patchValue(resp.opcC.value);
        this.pf16Form.get('factor').patchValue(resp.factor);
        this.pf16Form.get('index').patchValue(resp.index);

      },
      err=>console.log(err)
    )
  }

  handleDelete(id){
    var opc = confirm("¿Eliminar pregunta?");
    if (opc==true) this.adminService.deleteQuestion('pf16',id);
  }

  update(){
    this.pf16Service.updateQuestion(this.pf16Form.value).subscribe(
      resp=>window.location.reload(),
      err=>console.log(err)
    )
  }
  
  handleExchange(i){
    var pos = Number(prompt("Mover a posición: "));
    this.adminService.toggleQuestions('pf16',i,pos);
  }

}
